import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { WorkOrderSearchTextForm } from '../../../form-model/work-order-search-text.form.model';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-shop-management-search',
  imports: [FormsModule, ReactiveFormsModule, RouterModule],
  templateUrl: './shop-management-search.component.html',
  styleUrl: './shop-management-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchComponentSM {
  @Input({ required: true }) workOrderSearchTextForm!: FormGroup<WorkOrderSearchTextForm>;

  applySearchTextFilters() {
    const searchText = this.workOrderSearchTextForm.controls.searchText.value;
    if (searchText) {
      this.workOrderSearchTextForm.controls.searchText.setValue(searchText.trim());
    }
    this.workOrderSearchTextForm.controls.appliedWOSearchTextFilter.setValue(true);
  }
  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.addControlsToTheFormGroup();
  }

  isControlInErrorState(control: FormControl): boolean | null {
    if (control.invalid && control.touched) {
      return true;
    }
    return null;
  }

  private addControlsToTheFormGroup() {
    const validTextSearchPattern = /^\s*[a-zA-Z0-9]{3}\s*$/;
    this.workOrderSearchTextForm.addControl(
      'searchText',
      this.formBuilder.control<string | null>(null, {
        validators: [Validators.pattern(validTextSearchPattern)],
      }),
    );
    this.workOrderSearchTextForm.addControl('appliedWOSearchTextFilter', this.formBuilder.control<boolean | null>(null));
  }
}
